import {ApplicationConfig} from '@angular/core';
import {provideRouter, withDisabledInitialNavigation} from '@angular/router';
import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi
} from "@angular/common/http";
import {importProvidersFrom} from '@angular/core';
import {TranslateModule, TranslateService, TranslateLoader, TranslateCompiler} from '@ngx-translate/core';
import {Location, provideImageKitLoader} from '@angular/common';
import {LocalizeRouterSettings, LocalizeParser, withLocalizeRouter} from '@gilsdav/ngx-translate-router';
import {createTranslateLoader, createTranslateRouterLoader} from './shared/loader/translate-router.loader';
import {TranslateMessageFormatCompiler} from "ngx-translate-messageformat-compiler";
import {ImagekitioAngularModule} from "imagekitio-angular";
import {AuthInterceptor} from "./shared/interceptors/auth.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideImageKitLoader('https://ik.imagekit.io/tlob'),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    importProvidersFrom(
      ImagekitioAngularModule.forRoot({
        urlEndpoint: 'https://ik.imagekit.io/tlob',
        publicKey: 'public_mxQeRYD9aWrK8EppVimlFQfhKLk',
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler
        }
      })),
    provideRouter(
      routes,
      withDisabledInitialNavigation(),
      withLocalizeRouter(routes, {
        parser: {
          provide: LocalizeParser,
          useFactory: createTranslateRouterLoader,
          deps: [TranslateService, Location, LocalizeRouterSettings, HttpClient]
        },
        initialNavigation: true
      })
    ),
    provideAnimationsAsync(),
    // HTTP Interceptor registrieren:
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
};
